import { createFileRoute } from '@tanstack/react-router'
import { PaymentEditor } from '../-PaymentEditor'

export const Route = createFileRoute('/finance/payments/$id/')({
  component: PaymentDetailPage,
})

function PaymentDetailPage() {
  const { id } = Route.useParams()
  return <PaymentEditor id={id} />
}
